import styled from 'styled-components';

import { spacing } from 'ui/theme';
import { useColumns } from './Table';

import { useAlternatingRowBackgroundColor } from './useAlternatingRowBackgroundColor';

const useIsFirstColumn = (columnId: string) => useColumns()[0]?.id === columnId;
const useIsLastColumn = (columnId: string) => {
  const columns = useColumns();
  return columns[columns.length - 1]?.id === columnId;
};

export const Cell = styled.div<{ columnId: string }>`
  grid-column: col-${({ columnId }) => columnId} / span 1;
  padding: ${spacing.base} ${spacing.base} ${spacing.base} 0;
  ${({ columnId }) => useIsFirstColumn(columnId) && `padding-left: ${spacing.double};`}
  ${({ columnId }) => useIsLastColumn(columnId) && `padding-right: ${spacing.double};`}
  ${() => useAlternatingRowBackgroundColor()}
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
